import React, { useState } from "react";
import { isEmpty } from "ramda";
import {
  Box,
  TextField,
  FormControl,
  Chip,
  Grid,
  Typography,
} from "@mui/material";
import CustomizedChip from "./../../common/formElements/Chip";

interface Props {
  value: string[];
  label: string;
  onChange: (data: string[]) => void;
}

export default function ArrayInput({
  value,
  label,
  onChange,
}: Props): React.ReactElement {
  const [currentValue, setCurrentValue] = useState("");

  const Chips = (): JSX.Element => {
    return (
      <Box display="flex" flexWrap="wrap" mb={1}>
        {value?.map((val: string, idx) => {
          return (
            <Box mr={1} mb={1} mt={1} key={idx}>
              <CustomizedChip
                label={val}
                onDelete={() =>
                  onChange(
                    value.filter((x) => x.toLowerCase() !== val.toLowerCase())
                  )
                }
              />
            </Box>
          );
        })}
      </Box>
    );
  };

  return (
    <FormControl fullWidth>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="body2" display="block" gutterBottom>
            {label}
          </Typography>
          <Box mb={1}>{!isEmpty(value) ? <Chips /> : <Chip label="N/A" />}</Box>
        </Grid>

        <Grid item xs={12} md={5}>
          <TextField
            value={currentValue}
            variant="outlined"
            label="POS Device ID"
            fullWidth
            onKeyPress={(e: React.KeyboardEvent<HTMLInputElement>) => {
              if (e.key === "Enter") {
                e.preventDefault();
                const trimmedValue = currentValue.trim();
                if (!isEmpty(trimmedValue)) {
                  onChange([...value, trimmedValue]);
                }
                setCurrentValue("");
              }
            }}
            onBlur={() => {
              const trimmedValue = currentValue.trim();
              if (!isEmpty(trimmedValue)) {
                onChange([...value, trimmedValue]);
              }
              setCurrentValue("");
            }}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setCurrentValue(event.currentTarget.value);
            }}
          />
        </Grid>
      </Grid>
    </FormControl>
  );
}
